<div class="ng2-dropdown-container">
    <ng-content select="ng2-dropdown-button"></ng-content>
    <ng-content select="ng2-dropdown-menu"></ng-content>
</div>
